module.exports = function addKeyPressEventListener(element, keyCode, handler) {
  element.addEventListener('keypress', function (e) {
    if (e.which !== keyCode) { return; }
    handler(e);
  });
};



//////////////////
// WEBPACK FOOTER
// ./src/js/helpers/addkeypresseventlistener.js
// module id = 34
// module chunks = 0